<template>
	<section class="main-visual">
		<div class="container">
			<div class="main-visual-content">
				<img class="main-visual-content-logo" src="@/assets/img/main/dhfesta_logo_eng3.png" alt="2024 KOREA SHOPPING FESTA 동행축제 2024.12.1 - 12.28" />
				<!-- <img class="main-visual-content-model" src="@/assets/img/main/model_image_eng.png" alt="사람들" /> -->
			</div>
		</div>
		<div class="main-visual-wave">
			<img src="@/assets/img/main/main_wave.png" alt="" />
		</div>
	</section>
</template>
<script>
export default {
	name: 'EngMainLivePr',
	components: {},
	data: () => ({}),
	computed: {},
	created() {},
	mounted() {},
	methods: {},
};
</script>
